import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Mayi Mimarlık — mayimimarlik-6dfe5
const firebaseConfig = {
  apiKey: "AIzaSyDdf0d0ABgVzDvGH1aRoROzWthsIZ_viXQ",
  authDomain: "mayimimarlik-6dfe5.firebaseapp.com",
  projectId: "mayimimarlik-6dfe5",
  storageBucket: "mayimimarlik-6dfe5.firebasestorage.app",
  messagingSenderId: "771843191846",
  appId: "1:771843191846:web:68e63f2b5bf95a4eec62e7",
  measurementId: "G-G56JXPGB51",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error("Auth persistence error:", error);
});
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
